import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import Layout from "../components/Layout";
import { useContent } from "../contexts/SiteContentContext";

export default function Loja() {
  const [cases, setCases] = useState([]);
  const c = useContent("loja_page");

  useEffect(() => {
    api.get("/cases").then((res) => setCases(res.data));
  }, []);

  return (
    <Layout>
      <section className="pt-20 pb-12 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <p className="section-tag mb-4">{c.eyebrow || "Loja"}</p>
          <h1 className="headline text-5xl md:text-7xl lg:text-8xl mb-6">{c.title || "Todos os casos"}</h1>
          <p className="text-bone-muted text-base md:text-lg max-w-2xl">
            {c.subtitle || "Encomenda o teu dossier."}
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {cases.map((cc) => (
              <Link key={cc.id} to={`/casos/${cc.slug}`} data-testid={`loja-card-${cc.slug}`} className="group block">
                <div className="dossier overflow-hidden">
                  <div
                    className="aspect-[4/5] bg-cover bg-center relative transition-transform duration-700 group-hover:scale-105"
                    style={{ backgroundImage: `url(${cc.cover_image})` }}
                  >
                    <div className="absolute inset-0 bg-gradient-to-t from-ink-100 via-ink-100/30 to-transparent" />
                    <div className="absolute top-4 left-4 right-4 flex justify-between">
                      <span className="mono text-[10px] tracking-[0.3em] bg-ink-50/80 backdrop-blur px-3 py-1.5">{cc.code}</span>
                      {cc.status === "available" ? (
                        <span className="mono text-[10px] tracking-[0.3em] bg-blood text-white px-3 py-1.5">{c.available_badge || "DISPONÍVEL"}</span>
                      ) : (
                        <span className="mono text-[10px] tracking-[0.3em] bg-ink-50/80 backdrop-blur text-bone-muted px-3 py-1.5">{c.soon_badge || "EM BREVE"}</span>
                      )}
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="headline text-2xl mb-2 leading-tight">{cc.title}</h3>
                    <p className="text-bone-muted text-sm leading-relaxed mb-5">{cc.subtitle}</p>
                    <div className="flex items-end justify-between pt-4 border-t border-white/10">
                      <div>
                        <p className="mono text-[10px] text-bone-faded tracking-[0.3em]">PREÇO</p>
                        <p className="headline text-2xl text-blood">{cc.price.toFixed(2)}€</p>
                      </div>
                      <span className="mono text-[11px] text-bone-muted tracking-[0.2em] group-hover:text-white flex items-center gap-2 transition-colors">
                        Ver dossier <ArrowRight className="w-3.5 h-3.5" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
